import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-44" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-45" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-46" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-47" data-mp="57ebob4uv5ec">
            The Volleyball Ready™ Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-48" data-mp="3rgyrl5j7ekde">
            From an Overwhelmed Coach to a{' '}
            <span className="italic text-brand" data-id="element-49" data-mp="3dj0q30pzeifb">Tactical Elite.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-50" data-mp="3ihv5dsoqpouo">
            Give your sessions a clear rhythm, your players more technical
            confidence, and yourself the time to enjoy coaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-51" data-mp="1j9ujcajku3mf">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-52" data-mp="1szxb67eypbj6" data-mpi={index}>
              <dt className="sr-only" data-id="element-53" data-mp="10e4d2b4m2l2q">{stat.label}</dt>
              <dd data-id="element-54" data-mp="wc117le15egx">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-55" data-mp="wcitk6xkn8jk">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-56" data-mp="15bnrbb1b6xuo">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-57" data-mp="2gphu4qb488sg">
          <div className="grid md:grid-cols-2" data-id="element-58" data-mp="2ors7al23obk3">
            <div className="relative flex flex-col bg-sand p-8 sm:p-10" data-id="element-59" data-mp="2oqz9wap16yem">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-60" data-mp="2srsuau39lv2r">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="2xpuitujgmmlm" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-62" data-mp="32q8mz1hxxced">
                The cost of improvising
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-63" data-mp="2a1l1b4ta4l0a">
                BEFORE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-64" data-mp="2f04mh301tsrl">
                What planning from scratch quietly takes from your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-65" data-mp="1mbqo2m51sufi">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-66" data-mp="1rb38l08g5pex">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-67" data-mp="1espscn0ho52p" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative flex flex-col bg-white p-8 sm:p-10" data-id="element-68" data-mp="14x5wg0lxd6dy">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-69" data-mp="10v16pcylktwl">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-70" data-mp="r3odagx5hvog" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-71" data-mp="r1bw45z7vpcg">
                The Volleyball Ready™ system
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-72" data-mp="h47cacsug5yt">
                WITH VOLLEYBALL READY™
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-73" data-mp="11ujii8educ83">
                Walk into every practice with a clear, structured plan.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-74" data-mp="16suxexjjbcx6">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-75" data-mp="t1zib3ifzzl5">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-76" data-mp="j2qqohb1ux1y" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-77" data-mp="e5ql07i43wbd">
            A complete system to plan less and coach with more authority.
          </p>
        </div>
      </div>
    </section>;
}